export default {info: 'fa fa-info-circle',success: 'fa fa-check-circle',warning: 'fa fa-exclamation-circle',danger: 'fa fa-times-circle'
};
